import { createFileRoute } from "@tanstack/react-router";

import type { QueryClient } from "@tanstack/react-query";

import { accountSiteDetailsQueryOptions } from "@/api/recommendations";
import { RecommendationExclusionsPage } from "@/features/RecommendationExclusions/RecommendationExclusionsPage";

export const Route = createFileRoute(
  "/_auth/settings/$siteId/recommendation-exclusions",
)({
  loader: async ({ params, context }) => {
    const { queryClient } = context as { queryClient: QueryClient };
    const { siteId } = params;
    await queryClient.ensureQueryData(accountSiteDetailsQueryOptions(siteId));
  },
  component: RecommendationExclusionsPage,
});
